(function () {
  function findVariantByOptions(variants, optionValues) {
    if (!variants || !optionValues || !optionValues.length) return null;
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var options = variant.options;
      if (!options) {
        options = [variant.option1, variant.option2, variant.option3].filter(function (value) {
          return value != null && value !== '';
        });
      }
      if (options.length < optionValues.length) continue;
      var matched = true;
      for (var j = 0; j < optionValues.length; j++) {
        if (options[j] !== optionValues[j]) {
          matched = false;
          break;
        }
      }
      if (matched) return variant;
    }
    return null;
  }

  function initialFormVariantId(checkedVariant, formVariantId) {
    if (checkedVariant && checkedVariant.id != null && checkedVariant.id !== '') {
      return checkedVariant.id;
    }
    return formVariantId;
  }

  function pcSkuGalleryAction(isDesktop) {
    return isDesktop ? 'align' : 'thumbnail';
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      findVariantByOptions: findVariantByOptions,
      initialFormVariantId: initialFormVariantId,
      pcSkuGalleryAction: pcSkuGalleryAction
    };
    return;
  }

  function readConfig() {
    var el = document.getElementById('product-page-config');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  function suppressHeroGallery(ms) {
    window.srlPdpSuppressGalleryOpen = true;
    clearTimeout(window.srlPdpSuppressGalleryTimer);
    window.srlPdpSuppressGalleryTimer = setTimeout(function () {
      window.srlPdpSuppressGalleryOpen = false;
    }, ms || 800);
  }

  function alignVariantMedia(mediaId, lockedScrollY) {
    if (!/^\d+$/.test(mediaId)) return false;
    var carousel = document.querySelector('.shopify-section--main-product .product-gallery__carousel');
    if (!carousel) return false;
    var cell = carousel.querySelector('.product-gallery__media[data-media-id="' + mediaId + '"]');
    if (!cell) return false;
    var scrollY = lockedScrollY == null ? window.scrollY : lockedScrollY;
    carousel.querySelectorAll('[data-srl-sku-lead]').forEach(function (node) {
      node.removeAttribute('data-srl-sku-lead');
    });
    cell.setAttribute('data-srl-sku-lead', '');
    var cells = carousel.cells
      ? carousel.cells
      : Array.prototype.filter.call(carousel.children, function (node) {
        return !node.hasAttribute('hidden');
      });
    var index = -1;
    Array.prototype.forEach.call(cells, function (node, i) {
      if (node.getAttribute('data-media-id') === mediaId) index = i;
    });
    if (index >= 0 && typeof carousel.select === 'function') carousel.select(index, { instant: true });
    var thumbs = document.querySelectorAll('.shopify-section--main-product .product-gallery__thumbnail');
    var matched = null;
    for (var i = 0; i < thumbs.length; i++) {
      var on = thumbs[i].getAttribute('data-media-id') === mediaId;
      thumbs[i].setAttribute('aria-current', on ? 'true' : 'false');
      if (on) matched = thumbs[i];
    }
    if (matched && matched.parentElement) {
      var scroller = matched.parentElement;
      if (scroller.scrollHeight > scroller.clientHeight || scroller.scrollWidth > scroller.clientWidth) {
        scroller.scrollTo(
          matched.offsetLeft - scroller.clientWidth / 2 + matched.clientWidth / 2,
          matched.offsetTop - scroller.clientHeight / 2 + matched.clientHeight / 2
        );
      }
    }
    if (window.scrollY !== scrollY) window.scrollTo(0, scrollY);
    requestAnimationFrame(function () {
      if (window.scrollY !== scrollY) window.scrollTo(0, scrollY);
    });
    return true;
  }

  function clickMediaById(mediaId, lockedScrollY) {
    if (!mediaId) return;
    suppressHeroGallery(800);
    var id = String(mediaId).trim();
    if (pcSkuGalleryAction(window.matchMedia('(min-width: 1000px)').matches) === 'align' && alignVariantMedia(id, lockedScrollY)) {
      return;
    }
    var thumb = document.querySelector('.product-gallery__thumbnail[data-media-id="' + id + '"]');
    if (thumb) {
      thumb.click();
      return;
    }
    var carousel = document.querySelector('product-gallery scroll-carousel.product-gallery__carousel');
    var cells = carousel && carousel.cells
      ? carousel.cells
      : Array.prototype.filter.call(document.querySelectorAll('.product-gallery .product-gallery__media'), function (cell) {
        return !cell.hasAttribute('hidden');
      });
    var index = -1;
    Array.prototype.forEach.call(cells, function (cell, i) {
      if (cell.getAttribute('data-media-id') === id) index = i;
    });
    if (index >= 0 && carousel && typeof carousel.select === 'function') {
      carousel.select(index, { instant: true });
    }
  }

  function childSpanText(el) {
    var text = '';
    if (!el) return text;
    Array.prototype.forEach.call(el.children, function (child) {
      if (child.tagName === 'SPAN') text += child.textContent;
    });
    return text;
  }

  function findSpanText(el) {
    var text = '';
    if (!el) return text;
    el.querySelectorAll('span').forEach(function (span) {
      text += span.textContent;
    });
    return text;
  }

  function nextIf(el, selector) {
    var node = el && el.nextElementSibling;
    return node && node.matches(selector) ? node : null;
  }

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function saveRecentlyViewed(productId) {
    if (!productId) return;
    try {
      var recentlyViewedProducts = new Set(JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]'));
      recentlyViewedProducts.delete(productId);
      recentlyViewedProducts.add(productId);
      localStorage.setItem('theme:recently-viewed-products', JSON.stringify(Array.from(recentlyViewedProducts.values()).reverse()));
    } catch (error) {}
  }

  function onWindowLoad(fn) {
    if (document.readyState === 'complete') {
      fn();
    } else {
      window.addEventListener('load', fn);
    }
  }

  function initProductPage() {
    var config = readConfig();
    var root = document.querySelector('[data-srl-product-page]');
    if (root && root.dataset.srlProductBound === 'true') return;
    if (root) root.dataset.srlProductBound = 'true';

    saveRecentlyViewed(config.productId);

    document.querySelectorAll('.color-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        suppressHeroGallery(800);
        var scrollY = window.scrollY;
        setTimeout(function () {
          var params = new URLSearchParams(location.search);
          var variantId = params.get('variant') || location.search.slice(-14);
          var options = document.querySelectorAll('#select_variants_image option');
          for (var i = 0; i < options.length; i++) {
            if (variantId == options[i].value) {
              clickMediaById(options[i].textContent, scrollY);
              break;
            }
          }
        }, 100);

        var colorTextEl = document.getElementById('color-text');
        if (colorTextEl) colorTextEl.textContent = childSpanText(swatch);
      });
    });

    function setSizeHeading(sizeValue) {
      var sizeText = document.getElementById('size-text');
      if (sizeText) {
        sizeText.textContent = sizeValue || '';
        return;
      }
      var legend = document.querySelector('.variant-picker__option--size legend');
      if (legend) legend.textContent = (config.sizeLabel || '') + '　' + (sizeValue || '');
    }

    function firstVisibleSizeLabel() {
      var found = null;
      document.querySelectorAll('input[name="option2"]').forEach(function (input) {
        if (found) return;
        var label = nextIf(input, 'label');
        if (isVisible(label)) found = label;
      });
      return found;
    }

    function syncPickerLabels() {
      var colorInput = document.querySelector('input[name="option1"]:checked');
      if (colorInput) {
        var colorLabel = nextIf(colorInput, 'label');
        var srOnly = colorLabel && colorLabel.querySelector('span.sr-only');
        var colorText = (srOnly && srOnly.textContent) || colorInput.value;
        var colorTextEl = document.getElementById('color-text');
        if (colorTextEl) colorTextEl.textContent = colorText;
      }
      document.querySelectorAll('.block-swatch').forEach(function (el) {
        el.classList.remove('size_back_black');
      });
      var sizeInput = document.querySelector('input[name="option2"]:checked');
      if (!sizeInput) {
        var fallback = firstVisibleSizeLabel();
        if (fallback) fallback.click();
        sizeInput = document.querySelector('input[name="option2"]:checked');
      }
      var sizeSwatch = nextIf(sizeInput, '.block-swatch');
      if (sizeSwatch) sizeSwatch.classList.add('size_back_black');
      if (sizeInput) setSizeHeading(sizeInput.value);
    }

    document.querySelectorAll('.block-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var prev = swatch.previousElementSibling;
        var spanText = findSpanText(swatch) || (prev && prev.value) || '';
        document.querySelectorAll('.block-swatch').forEach(function (el) {
          el.classList.remove('size_back_black');
        });
        swatch.classList.add('size_back_black');
        if (prev && prev.getAttribute('name') === 'option2') {
          setSizeHeading(spanText);
        } else if (!prev || prev.getAttribute('name') !== 'option1') {
          setSizeHeading(spanText);
        }
      });
    });

    onWindowLoad(function () {
      var wkText = document.querySelector('.wk-text');
      var wkIcon = document.querySelector('.wk-icon');
      if (wkText && wkIcon) {
        wkIcon.parentNode.insertBefore(wkText, wkIcon);
      }

      var mxpr = document.getElementById('mxpr-already-exists');
      if (mxpr && getComputedStyle(mxpr).display == 'block') {
        var prev2 = mxpr.previousElementSibling && mxpr.previousElementSibling.previousElementSibling;
        if (prev2) prev2.style.display = 'none';
      }

      var hideColor = document.getElementById('hide_color');
      var colors = hideColor ? hideColor.value : '';
      colors.split(',').forEach(function (color) {
        if (color.trim() !== '') {
          document.querySelectorAll('.variant-picker__option-values input').forEach(function (input) {
            if (input.value === color) {
              var label = nextIf(input, 'label');
              if (label) label.style.display = 'none';
            }
          });
        }
      });

      var hideSize = document.getElementById('hide_size');
      var size = hideSize ? hideSize.value : '';
      size.split(',').forEach(function (sizeValue) {
        if (sizeValue.trim() !== '') {
          document.querySelectorAll('input').forEach(function (input) {
            if (input.value === sizeValue) {
              var label = nextIf(input, 'label');
              if (label) label.style.display = 'none';
            }
          });
        }
      });

      var urlParams = new URLSearchParams(window.location.search);
      var variantId = urlParams.get('variant');

      function syncGalleryForVariant(id) {
        var options = document.querySelectorAll('#select_variants_image option');
        for (var i = 0; i < options.length; i++) {
          if (String(id) === String(options[i].value)) {
            clickMediaById(options[i].textContent);
            break;
          }
        }
      }

      if (variantId) {
        function applyUrlVariant(attempt) {
          var pickerSelector = config.pickerFormId
            ? 'variant-picker[form="' + config.pickerFormId + '"]'
            : 'variant-picker';
          var picker = document.querySelector(pickerSelector);
          if (picker && typeof picker.selectVariant === 'function' && picker.product) {
            picker.selectVariant(parseInt(variantId, 10));
            syncGalleryForVariant(variantId);
            syncPickerLabels();
            if (!document.querySelector('input[name="option2"]:checked')) {
              var urlSize = firstVisibleSizeLabel();
              if (urlSize) urlSize.click();
              syncPickerLabels();
            }
            // 初期の click() はポインタ入力前なので :focus-visible になり、選択枠と重なる
            var active = document.activeElement;
            if (active && active.matches && active.matches('input[name^="option"]')) active.blur();
            return;
          }
          if ((attempt || 0) < 20) {
            setTimeout(function () {
              applyUrlVariant((attempt || 0) + 1);
            }, 50);
          }
        }
        applyUrlVariant(0);
      } else {
        function checkedOptionValues(picker) {
          var values = [];
          picker.querySelectorAll('[data-option-selector]').forEach(function (selector) {
            var input = selector.querySelector('input[name^="option"][type="hidden"], input[name^="option"]:checked, select[name^="option"]');
            if (input && input.value) values.push(input.value);
          });
          return values;
        }

        function currentFormVariantId(picker) {
          var formId = picker.getAttribute('form');
          var form = formId && document.forms[formId];
          if (!form) return '';
          var idInput = form.querySelector('input[name="id"]');
          if (!idInput && form.id && form.id.value != null) idInput = form.id;
          return idInput && idInput.value != null ? idInput.value : '';
        }

        function applyInitialSelection(attempt) {
          var pickerSelector = config.pickerFormId
            ? 'variant-picker[form="' + config.pickerFormId + '"]'
            : 'variant-picker';
          var picker = document.querySelector(pickerSelector);
          if (!(picker && picker.product && typeof picker.selectVariant === 'function')) {
            if ((attempt || 0) < 20) {
              setTimeout(function () {
                applyInitialSelection((attempt || 0) + 1);
              }, 50);
            } else {
              syncPickerLabels();
            }
            return;
          }

          var firstOption1 = document.querySelector('[name="option1"]');
          if (firstOption1) firstOption1.click();
          var firstOption2Label = firstVisibleSizeLabel();
          if (firstOption2Label) firstOption2Label.click();

          var firstVisibleLabel = Array.prototype.find.call(
            document.querySelectorAll('.variant-picker__option-values label'),
            isVisible
          );
          if (firstVisibleLabel) firstVisibleLabel.click();
          if (!document.querySelector('input[name="option2"]:checked')) {
            var retrySize = firstVisibleSizeLabel();
            if (retrySize) retrySize.click();
          }

          var checkedVariant = findVariantByOptions(picker.product.variants, checkedOptionValues(picker));
          var currentId = currentFormVariantId(picker);
          var nextId = initialFormVariantId(checkedVariant, currentId);
          if (checkedVariant && String(nextId) !== String(currentId)) {
            picker.selectVariant(parseInt(nextId, 10));
          }
          syncPickerLabels();
          // 初期の click() はポインタ入力前なので :focus-visible になり、選択枠と重なる
          var active = document.activeElement;
          if (active && active.matches && active.matches('input[name^="option"]')) active.blur();
        }

        applyInitialSelection(0);
      }
    });

    document.querySelectorAll('.metafield-multi_line_text_field').forEach(function (field) {
      var text = field.textContent;
      if (text.indexOf('style') >= 0) {
        field.innerHTML = text;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }
})();
